import { useEffect, useState } from 'react';
import { api } from '../../api.js';
import { Spinner, ErrorNote } from '../../components.jsx';

const VIEWS = [
  { id: 'today', label: 'Today' },
  { id: 'week', label: 'Week' },
  { id: 'month', label: 'Month' },
];

function groupByDay(events) {
  const groups = new Map();
  for (const e of events) {
    const key = e.start.slice(0, 10);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(e);
  }
  return [...groups.entries()];
}

function fmtHeading(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffDays = Math.round((d - today) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Tomorrow';
  return d.toLocaleDateString('en-AU', { weekday: 'short', day: '2-digit', month: 'short' });
}

function fmtTime(iso, allDay) {
  if (allDay) return 'All day';
  return new Date(iso).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' });
}

export default function CalendarWidget() {
  const [view, setView] = useState('week');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setData(null);
    setError(null);
    api.get(`/api/widgets/calendar?view=${view}`).then(setData).catch((e) => setError(e.message));
  }, [view]);

  return (
    <div className="card flex flex-col p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 className="min-w-0 truncate text-sm font-bold uppercase tracking-wide text-steel">Leave & events</h2>
        <div className="flex shrink-0 gap-1 rounded-lg bg-steel/10 p-0.5">
          {VIEWS.map((v) => (
            <button
              key={v.id}
              onClick={() => setView(v.id)}
              className={`rounded-md px-2 py-1 text-xs font-medium transition ${view === v.id ? 'bg-navy text-white' : 'text-steel hover:bg-steel/10'}`}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
      {error && <ErrorNote>Couldn't load the calendar ({error})</ErrorNote>}
      {!data && !error && <Spinner label="Loading calendar…" />}
      {data && data.events.length === 0 && <p className="text-sm text-steel">Nothing scheduled.</p>}
      {data && data.events.length > 0 && (
        <div className="min-h-0 flex-1 space-y-3 overflow-y-auto pr-1">
          {groupByDay(data.events).map(([day, events]) => (
            <div key={day}>
              <div className="mb-1 text-xs font-bold uppercase tracking-wide text-steel">{fmtHeading(day)}</div>
              <ul className="space-y-1">
                {events.map((e) => (
                  <li key={e.id} className="flex items-start gap-2 text-sm">
                    <span className="mt-0.5 w-14 shrink-0 text-xs text-steel">{fmtTime(e.start, e.allDay)}</span>
                    <span className="min-w-0 truncate">{e.title}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
